export default "__VITE_ASSET__BfPZvIqs__"